<template>
    <div class="row">
        <div class="col-12">
            <h2 class="m-0 h1 text-uppercase">{{ $t('partido.completar_datos') }}</h2>
            <div class="subtitle h3 light mb-3 mb-lg-5">
                {{ !reserva_instalaciones ? $t('partido.completa_info') : $t('partido.completa_reserva') }}.
            </div>
            <ValidationObserver tag="form" ref="observer2" @submit.prevent="submit()">
                <div class="row">
                    <div class="col-12 col-lg-6">
                        <FormInput
                            v-model="localDatosCompradores.nombre"
                            id="nombre"
                            data-cy="nombre"
                            rules="required"
                            :disabled="desactivar"
                            :label="$t('formularios.nombre')"
                            :name="$t('formularios.nombre')"
                        />
                    </div>
                    <div class="col-12 col-lg-6">
                        <FormInput
                            v-model="localDatosCompradores.apellidos"
                            id="apellidos"
                            data-cy="apellidos"
                            rules="required"
                            :disabled="desactivar"
                            :label="$t('formularios.apellidos')"
                            :name="$t('formularios.apellidos')"
                        />
                    </div>
                    <b-col cols="12" md="6" lg="6">
                        <DocumentoTipo
                            id="tipo-documento-comprador"
                            :value="localDatosCompradores.tipoDocumentoSeleccionado.type"
                            :index="0"
                            @input="val => { localDatosCompradores.tipoDocumentoSeleccionado.type = val; }"
                        />
                    </b-col>
                    <div class="col-12 col-lg-6">
                        <DocumentoValor
                            :type="localDatosCompradores.tipoDocumentoSeleccionado.type"
                            :value="localDatosCompradores.dni"
                            :index="0"
                            @input="val => { localDatosCompradores.dni = val; }"
                        />
                    </div>
                    <div class="col-12 col-lg-6">
                        <FormInput
                            v-model="localDatosCompradores.email"
                            id="email"
                            data-cy="email"
                            vid="confirmation"
                            rules="required|email"
                            :infoText="disabledEmailPreventa ? 'No puedes modificar el email en la preventa' : null"
                            :disabled="desactivar || disabledEmailPreventa"
                            :label="$t('formularios.email')"
                            :name="$t('formularios.email')"
                        />
                    </div>
                    <div class="col-12 col-lg-6">
                        <FormInput
                            v-model="localDatosCompradores.email_confirmation"
                            id="email_confirmation"
                            data-cy="email_confirmation"
                            :rules="'required|confirmed_ci:@confirmation'"
                            :disabled="desactivar || disabledEmailPreventa"
                            :label="$t('formularios.confirmar_email')"
                            :name="$t('formularios.confirmar_email')"
                        />
                    </div>
                    <div class="col-12 col-lg-6">
                        <FormInput
                            v-model="localDatosCompradores.edad"
                            id="edad"
                            data-cy="edad"
                            rules="required"
                            :disabled="desactivar"
                            :label="$t('formularios.edad')"
                            :name="$t('formularios.edad')"
                        />
                    </div>
                    <div class="col-12 col-lg-6">
                        <div class="form-group">
                            <label>{{ $t('formularios.telefono') }}</label>
                            <PhoneInput
                                id="telefono-comprador"
                                :phone="localDatosCompradores.telefono ?? null"
                                :desactivar="desactivar"
                                :forceValidate="false"
                                dataCy="telefono"
                                @setNumber="(number) => localDatosCompradores.telefono = number"
                                @validNumber="(valid) => isValidNumber = valid"
                            />
                        </div>
                    </div>
                    <div class="col-12 col-lg-6">
                        <FormInput
                            v-model="localDatosCompradores.cp"
                            id="cp"
                            data-cy="cp"
                            rules="required"
                            :disabled="desactivar"
                            :label="$t('formularios.cp')"
                            :name="$t('formularios.cp')"
                        />
                    </div>
                    <template v-if="fields && fields.length > 0">
                        <div v-for="(field, index) in fields" :key="index" :class="'col-12' + (field.type !== 'textarea' ? ' col-lg-6' : '')">
                            <FieldComponent
                                :field="field"
                                :desactivar="desactivar"
                                v-model="localDatosCompradores.properties[field.name]"
                            />
                        </div>
                    </template>
                    <template v-if="errors">
                        <div class="col-11 alert alert-danger m-auto" style="margin-bottom: 15px !important;" v-for="(error, index) in errors" :key="index" id="errors">
                            <ul class="p-1 m-0">
                                <li><b>{{ 'El campo ' + error.message }}</b></li>
                            </ul>
                        </div>
                    </template>
                    <div class="col-12">
                        <div v-if="!reserva_instalaciones">
                            <p class="h4 text-bold my-3">
                                {{ $t('partido.entradas_adquiridas_titulo', { entradas: footer.termino_entradas }) }}
                            </p>
                            <br/>
                            <p class="text-bold">
                                👉 {{ $t('partido.entradas_adquiridas', { entradas: footer.termino_entradas }) }}
                            </p>
                            <br/>
                            <p class="text-bold">
                                👉 {{ $t('partido.entradas_adquiridas_spam') }}
                            </p>
                        </div>
                        <div v-else>
                            <p class="h4 text-bold my-3">
                                {{  $t('partido.reservas_adquiridas_titulo', { entradas: footer.termino_entradas }) }}
                            </p>
                            <br/>
                            <p class="text-bold">
                                👉 {{ $t('partido.reservas_adquiridas', { entradas: footer.termino_entradas }) }}
                            </p>
                            <br/>
                            <p class="text-bold">
                                👉 {{ $t('partido.reservas_adquiridas_spam') }}
                            </p>
                        </div>
                        <div v-if="!reserva_instalaciones">
                            <p class="text-bold">👉 {{ $t('partido.entradas_adquiridas_whatsapp', { entradas: footer.termino_entradas }) }}</p>
                            <p class="text-bold">👉 {{ $t('partido.entradas_adquiridas_whatsapp_incluir') }}</p>
                            <p class="text-bold">👉 {{ $t('partido.entradas_adquiridas_whatsapp_minutos') }}</p>
                        </div>
                        <div v-else>
                            <p class="text-bold">👉 {{ $t('partido.reservas_adquiridas_whatsapp', { entradas: footer.termino_entradas }) }}</p>
                            <p class="text-bold">👉 {{ $t('partido.reservas_adquiridas_whatsapp_incluir') }}</p>
                            <p class="text-bold">👉 {{ $t('partido.reservas_adquiridas_whatsapp_minutos') }}</p>
                        </div>
                        <p v-if="solicitar_datos"><b>👉 {{ $t(reserva_instalaciones ? 'partido.reserva_nominativas' : 'partido.entrada_nominativas', { entradas: footer.termino_entradas }) }}</b></p>
                    </div>
                    <div class="col-12" v-if="solicitar_datos && limite_cambiar_datos_entrada && limite_tiempo_cambiar_datos_entrada">
                        <p>
                            <b>{{ $t('partido.limite_tiempo_cambiar_datos', { tiempo: limite_tiempo_cambiar_datos_entrada.nombre }) }}</b>
                        </p>
                    </div>
                </div>

                <template v-if="! solicitar_datos && Array.isArray(asientos)">
                    <div v-for="(asiento, index) in entradasFormatted" :key="index" class="col-12">
                        <div class="form-group-multiselect">
                            <label for="precio">
                                {{ $t((!reserva_instalaciones ? 'formularios.precio_entrada' : 'formularios.precio_reserva'), { index: ++index }) }}
                                <span v-if="!asiento.asiento?.fila == 0 && url.includes('reservas')">- {{ $t('general.sector') }}: {{ asiento.asiento?.zona_nombre }} - {{ $t('general.fila') }}: {{ asiento.asiento?.fila }} - {{ $t('general.butaca') }}: {{ asiento.asiento?.asiento }}</span>
                                <span v-if="asiento.visibilidad_reducida" class="text-danger">
                                    - {{ nombreVisibilidadReducida }}
                                </span>
                                <span v-if="asiento.porcentaje_visibilidad" class="text-danger">
                                    : {{ asiento.porcentaje_visibilidad }}%
                                </span>
                            </label>
                            <ValidationProvider
                                :name="'Precio entrada ' + index+1"
                                :rules="'required'"
                                mode="passive"
                                v-slot="{ errors }"
                            >
                                <multiselect
                                    v-if="asiento.asiento"
                                    v-model="asiento.precio"
                                    :show-labels="false"
                                    :options="asiento.precios"
                                    :allow-empty="false"
                                    label="descripcion"
                                    :data-cy="'precio-entrada-' + index+1"
                                    :custom-label="customLabel"
                                    :class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                                    :disabled="desactivar || asiento.tienePrecio"
                                />
                                <multiselect
                                    v-else
                                    v-model="asiento.precioSeleccionado"
                                    :show-labels="false"
                                    :options="asiento.precios"
                                    :allow-empty="false"
                                    label="descripcion"
                                    :data-cy="'precio-entrada-' + index+1"
                                    :custom-label="customLabel"
                                    :class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                                    :disabled="desactivar || asiento.tienePrecio"
                                />
                            </ValidationProvider>
                        </div>
                    </div>
                </template>
                <template v-if="solicitar_datos && Array.isArray(asientos)">
                    <div v-for="(asiento, index) in entradasFormatted" class="row" :key="index">
                        <template v-if="asiento.asiento">
                            <div class="col-12 subtitle h3 light mb-3 mb-lg-3 mt-lg-5">
                                {{ asiento.asiento?.zona_nombre }} -
                                <template v-if="asiento.asiento?.fila > 0 && asiento.asiento?.asiento > 0">
                                    {{ $t('general.fila') }}: {{ asiento.asiento?.fila }} {{ $t('general.butaca') }}: {{ asiento.asiento?.asiento }}
                                </template>
                            </div>
                            <MensajeNombresDuplicados v-if="esDuplicado == true"/>
                            <div class="col-12 col-lg-4">
                                <FormInput
                                    :disabled="desactivar"
                                    :label="$t('formularios.nombre')"
                                    :id="'asiento-nombre-' + calcRow(index)"
                                    :data-cy="'asiento-nombre-' + calcRow(index)"
                                    :name="$t('formularios.nombre') + ' de la entrada ' + calcRow(index)"
                                    rules="required"
                                    v-model="asiento.nombre"
                                />
                            </div>
                            <div class="col-12 col-lg-4">
                                <FormInput
                                    :disabled="desactivar"
                                    :label="$t('formularios.apellidos')"
                                    :id="'asiento-apellidos-'+ calcRow(index)"
                                    :data-cy="'asiento-apellidos-'+ calcRow(index)"
                                    :name="$t('formularios.apellidos') + ' de la entrada ' + calcRow(index)"
                                    rules="required" v-model="asiento.apellidos"
                                />
                            </div>
                            <template v-if="teatro.hash != '14wAm2L1Jxx5B3J3xBkH'">
                                <b-col cols="12" md="6" lg="4">
                                    <DocumentoTipo
                                        :id="'tipo-documento-' + calcRow(index)"
                                        :value="asiento.tipoDocumentoSeleccionado.type"
                                        :key="'tipo-doc-' + index + '-' + asiento.tipoDocumentoSeleccionado.type"
                                        :index="calcRow(index)"
                                        @input="val => { asiento.tipoDocumentoSeleccionado.type = val; }"
                                    />
                                </b-col>
                                <div class="col-12 col-lg-4">
                                    <DocumentoValor
                                        :type="asiento.tipoDocumentoSeleccionado.type"
                                        :value="asiento.dni"
                                        :index="calcRow(index)"
                                        @input="val => { asiento.dni = val; }"
                                    />
                                </div>
                                <div class="col-12 col-lg-4">
                                    <label>{{ $t('formularios.telefono') }}</label>
                                    <PhoneInput
                                        :id="'5' + calcRow(index)"
                                        :dataCy="'asiento-telefono-' + calcRow(index)"
                                        :phone="asiento.telefono ?? null"
                                        :desactivar="desactivar"
                                        :forceValidate="false"
                                        :error_telefono="true"
                                        @setNumber="(number) => asiento.telefono = number"
                                        @validNumber="(valid) => {
                                            isValidNumberEntrada = valid
                                        }"
                                    />
                                </div>
                            </template>
                        </template>
                        <template v-if="asiento.svg_code">
                            <div v-if="asiento.numero" class="col-12 subtitle h3 light mb-3 mb-lg-3 mt-lg-5">
                                {{ asiento.name }} - N.º: {{ asiento.numero }}
                            </div>
                            <div v-else class="col-12 subtitle h3 light mb-3 mb-lg-3 mt-lg-5">
                                {{ asiento.name }} - {{ $t('general.sector') }}: {{ asiento.sector }} - {{ $t('general.fila') }}: {{ asiento.fila }} - {{ $t('general.butaca') }}: {{ asiento.butaca }}
                            </div>
                            <MensajeNombresDuplicados v-if="esDuplicado == true"/>
                            <div class="col-12 col-lg-4">
                                <FormInput
                                    :disabled="desactivar"
                                    :label="$t('formularios.nombre')"
                                    :id="'asiento-nombre-' + calcRow(index)"
                                    :data-cy="'asiento-nombre-' + calcRow(index)"
                                    :name="$t('formularios.nombre') + ' de la entrada ' + calcRow(index)"
                                    rules="required" v-model="asiento.nombre"
                                />
                            </div>
                            <div class="col-12 col-lg-4">
                                <FormInput
                                    :disabled="desactivar"
                                    :label="$t('formularios.apellidos')"
                                    :id="'asiento-apellidos-' + calcRow(index)"
                                    :data-cy="'asiento-apellidos-' + calcRow(index)"
                                    :name="$t('formularios.apellidos') + ' de la entrada ' + calcRow(index)"
                                    rules="required"
                                    v-model="asiento.apellidos"
                                />
                            </div>
                            <template v-if="teatro.hash != '14wAm2L1Jxx5B3J3xBkH'">
                                <b-col cols="12" md="6" lg="4">
                                    <DocumentoTipo
                                        :id="'tipo-documento-' + calcRow(index)"
                                        :data-cy="'tipo-documento-' + calcRow(index)"
                                        :value="asiento.tipoDocumentoSeleccionado.type"
                                        :key="'tipo-doc-' + index + '-' + asiento.tipoDocumentoSeleccionado.type"
                                        :index="calcRow(index)"
                                        @input="val => { asiento.tipoDocumentoSeleccionado.type = val; }"
                                    />
                                </b-col>
                                <div class="col-12 col-lg-4">
                                    <DocumentoValor
                                        :type="asiento.tipoDocumentoSeleccionado.type"
                                        :value="asiento.dni"
                                        :index="calcRow(index)"
                                        @input="val => { asiento.dni = val; }"
                                    />
                                </div>
                                <div class="col-12 col-lg-4">
                                    <label>{{ $t('formularios.telefono') }}</label>
                                    <PhoneInput
                                        :id="'asiento-telefono-' + calcRow(index)"
                                        :dataCy="'asiento-telefono-' + calcRow(index)"
                                        :phone="asiento.telefono ?? null"
                                        :desactivar="desactivar"
                                        :forceValidate="false"
                                        :error_telefono="true"
                                        @setNumber="(number) => asiento.telefono = number"
                                        @validNumber="(valid) => {
                                            isValidNumberEntrada = valid
                                        }"
                                    />
                                </div>
                            </template>
                        </template>
                        <b-col cols="12" v-if="! lfp">
                            <div class="form-group">
                                <label for="precio">{{ $t((!reserva_instalaciones ? 'formularios.precio_entrada' : 'formularios.precio_reserva'), { index: ++index }) }}</label>
                                <ValidationProvider
                                    :name="'Precio entrada ' + calcRow(index)"
                                    :rules="'required'"
                                    mode="passive"
                                    v-slot="{ errors }"
                                >
                                    <multiselect
                                        v-if="asiento.asiento"
                                        v-model="asiento.precio"
                                        :show-labels="false"
                                        :data-cy="'precio-entrada-' + calcRow(index)"
                                        :options="asiento.precios"
                                        :allow-empty="false"
                                        label="descripcion"
                                        :custom-label="customLabel"
                                        :class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                                        :disabled="desactivar || asiento.tienePrecio"
                                    />
                                    <multiselect
                                        v-else
                                        v-model="asiento.precioSeleccionado"
                                        :data-cy="'precio-entrada-' + calcRow(index)"
                                        :show-labels="false"
                                        :options="asiento.precios"
                                        :allow-empty="false"
                                        label="descripcion"
                                        :custom-label="customLabel"
                                        :class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                                        :disabled="desactivar || asiento.tienePrecio"
                                    />
                                </ValidationProvider>
                            </div>
                        </b-col>
                    </div>
                </template>
                <DatosProductosComponent v-if="Array.isArray(productos) && productos.length > 0" :productos="productos" />
                <template v-if="solicitar_datos && Array.isArray(entradas)">
                    <div v-for="(entrada, index) in array_entradas" class="row" :key="index">
                        <div class="col-12 subtitle h3 light mb-3 mb-lg-3 mt-lg-5">
                            {{ calcRow(index) + ' - ' + entrada.name }}
                        </div>
                        <div class="col-12 col-lg-4">
                            <FormInput :disabled="desactivar" :label="$t('formularios.nombre')" :name="$t('formularios.nombre') + ' de la entrada ' + calcRow(index)" rules="required" v-model="entrada.nombre" />
                        </div>
                        <div class="col-12 col-lg-4">
                            <FormInput :disabled="desactivar" :label="$t('formularios.apellidos')" :name="$t('formularios.apellidos') + ' de la entrada ' + calcRow(index)" rules="required" v-model="entrada.apellidos" />
                        </div>
                        <template v-if="teatro.hash != '14wAm2L1Jxx5B3J3xBkH'">
                            <div class="col-12 col-lg-4">
                                <label>{{ $t('formularios.telefono') }}</label>
                                <PhoneInput
                                    :id="'asiento-telefono-' + calcRow(index)"
                                    :dataCy="'asiento-telefono-' + calcRow(index)"
                                    :phone="entrada.telefono ?? null"
                                    :desactivar="desactivar"
                                    :forceValidate="true"
                                    :error_telefono="true"
                                    @setNumber="(number) => entrada.telefono = number"
                                    @validNumber="(valid) => isValidNumberEntrada = valid"
                                />
                            </div>
                        </template>
                    </div>
                </template>
                <button
                    id="compra-responsive"
                    :class="['button', 'large-button', { 'effect-button': !desactivar }]"
                    type="submit"
                    :disabled="desactivar || loading"
                >
                    <span>{{ $t('partido.continuar') }}</span>
                </button>

                <span
                    v-if="!desactivar"
                    id="atras"
                    :class="['button', 'large-button', 'ml-lg-3', 'compra-responsive', { 'effect-button': !desactivar }]"
                    @click="cambiarAsiento()"
                >
                    <span>{{ $t('formularios.atras') }}</span>
                </span>

                <button
                    v-else
                    :disabled="desactivar"
                    :class="['button', 'large-button', 'ml-lg-3', 'compra-responsive', { 'effect-button': !desactivar }]"
                    @click="cambiarAsiento()"
                >
                    <span>{{ $t('formularios.atras') }}</span>
                </button>
            </ValidationObserver>
        </div>
    </div>
</template>

<script>
    import MensajeNombresDuplicados from './components/MensajeNombresDuplicados.vue';
    import { isMobileOnly, isTablet, isBrowser } from 'mobile-device-detect';
    import FieldComponent from '@/components/common/FieldComponent';
    import PhoneInput from '@/components/common/PhoneInput.vue';
    import DatosProductosComponent from './components/productos/DatosProductosComponent.vue';
    import DocumentoTipo from "@/components/common/DocumentoTipo";
    import DocumentoValor from "@/components/common/DocumentoValor";
    import { claveVisibilidad } from '@/utils/visibilidadReducida';

    export default {
        props: [
            'datos_compradores', 'generos', 'solicitar_datos', 'productos', 'asientos', 'entradas', 'loading',
            'lfp', 'desactivar', 'plazas', 'limite_cambiar_datos_entrada', 'limite_tiempo_cambiar_datos_entrada',
            'fields', 'errors', 'reserva_instalaciones', 'event'
        ],
        data() {
            return {
                esDuplicado: false,
                datos_guardados: false,
                isValidNumber: false,
                isValidNumberEntrada: true,
                localDatosCompradores: this.datos_compradores,
                disabledEmailPreventa: false,
                tiposDocumento: [
                    { type: "DNI", value: "" },
                    { type: "NIE", value: "" },
                    { type: "NIF", value: "" },
                    { type: "PASAPORTE", value: "" },
                    { type: "OTROS", value: "" }
                ]
            }
        },
        mounted() {
            this.$refs.observer2.reset();
        },
        created() {
            this.localDatosCompradores.tipoDocumentoSeleccionado = this.tiposDocumento.find(tipo => tipo.type === 'DNI');

            if (!this.localDatosCompradores.email_confirmation && this.localDatosCompradores.email) {
                this.localDatosCompradores.email_confirmation = this.localDatosCompradores.email;
            }

            this.setEmail();

            if (this.asientos && Array.isArray(this.asientos)) {
                this.asientos.forEach((asiento, index) => {
                    if (!asiento.tipoDocumentoSeleccionado) {
                        this.$set(asiento, 'tipoDocumentoSeleccionado', { ...this.tiposDocumento.find(tipo => tipo.type === 'DNI') });
                    }

                    if (index === 0) {
                        asiento.nombre = this.localDatosCompradores.nombre;
                        asiento.apellidos = this.localDatosCompradores.apellidos;
                        asiento.dni = this.localDatosCompradores.dni;
                        asiento.telefono = this.localDatosCompradores.telefono;
                    } else {
                        asiento.nombre = '';
                        asiento.apellidos = '';
                        asiento.dni = '';
                        asiento.telefono = null;
                    }
                });
            }

            if (this.plazas && Array.isArray(this.plazas)) {
                this.plazas.forEach(plaza => {
                    if (plaza.precios && plaza.precios.length === 1 && !plaza.precioSeleccionado) {
                        this.$set(plaza, 'precioSeleccionado', plaza.precios[0]);
                    }
                });
            }

            if (this.fields && this.fields.length > 0) {
                this.localDatosCompradores.properties = {};
                this.fields.forEach(field => {
                    this.localDatosCompradores.properties[field.name] = '';
                });
            }
            this.añadirDispositivo();

            if (this.url.includes('reservas')) {
                if (this.asientos) {
                    this.asientos.forEach(asiento => {
                        if (!asiento.precioSeleccionado)
                            asiento.precioSeleccionado = asiento.precio;

                        if (asiento.precio || asiento.precioSeleccionado) {
                            asiento.tienePrecio = true;
                        } else {
                            asiento.tienePrecio = false;
                        }
                    })
                }

                if (this.plazas) {
                    this.plazas.forEach(plaza => {
                        if (!plaza.precioSeleccionado)
                            plaza.precioSeleccionado = plaza.precio;

                        if (plaza.precio || plaza.precioSeleccionado) {
                            plaza.tienePrecio = true;
                        } else {
                            plaza.tienePrecio = false;
                        }
                    })
                }
            }
        },
        computed: {
            nombreVisibilidadReducida() {
                return this.$t(claveVisibilidad('visibilidad_reducida.nombre', this.$route?.params?.sesion_id ?? null, clave => this.$te(clave)));
            },
            array_entradas() {
                var array = [];

                if(Array.isArray(this.entradas)) {
                    for (var i = 0; i < this.entradas.length; i++) {
                        for (var j = 0; j < this.entradas[i].unidades; j++) {
                            array.push({
                                name: this.entradas[i].name
                            });
                        }
                    }
                }
                return array;
            },
            footer() {
                return this.$store.getters.getFooter;
            },
            entradasFormatted() {
                if (this.plazas) {
                    this.plazas.forEach(plaza => {
                        if (!plaza.tipoDocumentoSeleccionado) {
                            this.$set(plaza, 'tipoDocumentoSeleccionado', { ...this.tiposDocumento.find(tipo => tipo.type === 'DNI') });
                        }
                    });
                }

                if (this.asientos && this.plazas) {
                    return [...this.asientos].concat(...this.plazas);
                } else if (this.asientos && !this.plazas) {
                    return this.asientos;
                } else {
                    return this.plazas;
                }
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            url() {
                return window.location.href;
            },
            user() {
                return this.$store.getters.getUser;
            }
        },
        methods: {
            customLabel({ descripcion, precio }) {
                return `${descripcion} – ${precio}€`
            },
            terminar() {
                this.setEmail();
                this.$emit('terminar', this.array_entradas);
                this.datos_guardados = true;
            },
            checkDuplicado() {
                if (Array.isArray(this.asientos) && this.asientos.length > 0) {
                    const buscarDni = new Set();
                    let duplicadoEncontrado = false;

                    for (const asiento of this.asientos) {
                        if (asiento.dni) {
                            const dniNormalizado = asiento.dni.toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, "");
                            if (buscarDni.has(dniNormalizado)) {
                                duplicadoEncontrado = true;
                                break;
                            }
                            buscarDni.add(dniNormalizado);
                        }
                    }

                    this.esDuplicado = duplicadoEncontrado;
                } else {
                    this.esDuplicado = false;
                }
            },
            async submit() {
                const isValid = await this.$refs.observer2.validate();
                if (this.solicitar_datos) {
                    this.checkDuplicado();
                }
                if (this.esDuplicado == false) {
                    if(isValid && this.isValidNumber && this.isValidNumberEntrada) {
                        this.terminar();
                    } else {
                        this.$nextTick(function() {
                            this.$scrollTo('.is-invalid', 100)
                        });
                    }
                }
            },
            calcRow(index) {
                return ++index;
            },
            cambiarAsiento() {
                if (this.plazas && this.plazas.length > 0) {
                    this.$emit('cambiar-asiento', true);
                } else {
                    this.$emit('cambiar-asiento', false);
                }
                if(!this.event.tiene_productos){
                    this.borrarSesion();
                }
            },
            borrarSesion() {
                if (sessionStorage.getItem('session_id')) {
                    const params = {
                        session_id: sessionStorage.getItem('session_id'),
                        filters: {
                            session_id: sessionStorage.getItem('session_id'),
                            tid: this.configuracion.hash_teatro
                        },
                        tid: this.configuracion.hash_teatro,
                    };

                    this.$store.dispatch(this.config.getVuexAlias('front.borrar.sesion'), params).then(res => {
                    });

                    sessionStorage.removeItem('session_id');
                }
            },
            añadirDispositivo() {
                if (isMobileOnly) this.localDatosCompradores.dispositivo = 0;
                if (isTablet) this.localDatosCompradores.dispositivo = 1;
                if (isBrowser) this.localDatosCompradores.dispositivo = 2;
            },
            setEmail() {
                if (this.user && this.event?.preventa?.venta_preventa_activa) {
                    this.localDatosCompradores.email = this.user.email;
                    this.localDatosCompradores.email_confirmation = this.user.email;
                    this.disabledEmailPreventa = true;
                }
            }
        },
        components: {
            MensajeNombresDuplicados, FieldComponent, PhoneInput, DatosProductosComponent,
            DocumentoTipo, DocumentoValor
        }
    }
</script>

<style scoped>
    .form-group-multiselect {
        margin-left: -1em;
        margin-bottom: 1em;
    }
    .multiselect > .multiselect__tags {
        background-color: white;
        border: none;
    }

    .multiselect > .multiselect__content-wrapper {
        right: 0;
    }

    .multiselect {
        border-bottom: 1px solid black;
        border-radius: 0;
        width: 95.6%;
        height: 10%;
    }

    @media (max-width: 992px) {
        .multiselect {
            width: 97.2%;
        }
    }

    @media (max-width: 700px) {
       .button.large-button {
            min-width: 40vw !important;
            margin-right: 4%;
        }

        #compra-responsive {
            min-width: 45vw;
            margin-left: 2px;
            font-size: 14px;
        }
        .compra-responsive {
            min-width: 40vw !important;
            margin-left: 5px !important;
            font-size: 14px !important;
        }
    }
</style>
